var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockedCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 60,
    viewBox: "0 0 49 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_349)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2258 14.6154C14.2258 9.09252 18.8258 4.61538 24.5 4.61538C30.1742 4.61538 34.7742 9.09252 34.7742 14.6154V21.5385H14.2258V14.6154ZM9.48387 21.5385V14.6154C9.48387 6.54354 16.2067 0 24.5 0C32.7933 0 39.5161 6.54354 39.5161 14.6154V21.5385H40.3064C45.1078 21.5385 49 25.3268 49 30V51.5385C49 56.2117 45.1078 60 40.3064 60H8.69355C3.89218 60 0 56.2117 0 51.5385V30C0 25.3268 3.89218 21.5385 8.69355 21.5385H9.48387ZM26.871 41.6902C28.2885 40.8923 29.2419 39.4006 29.2419 37.6923C29.2419 35.1434 27.1188 33.0769 24.5 33.0769C21.8812 33.0769 19.7581 35.1434 19.7581 37.6923C19.7581 39.4006 20.7115 40.8923 22.129 41.6902V48.4615C22.129 49.736 23.1906 50.7692 24.5 50.7692C25.8094 50.7692 26.871 49.736 26.871 48.4615V41.6902Z",
    fill: "#A4A6DE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedCalendar);
export default __webpack_public_path__ + "static/media/locked-calendar.d134817a5ddc50793ab41c5181423c7b.svg";
export { ForwardRef as ReactComponent };